export const MORNING_REPORT_PATH = "/dashboard/morning-report";

/** MorningReport's own domain, served by the same site as HealthDesk. */
export const isMorningReportDomain = (hostname = window.location.hostname) =>
  ["morningreport.si", "www.morningreport.si"].includes(hostname);

export const morningReportSessionPath = (sessionId) =>
  `${MORNING_REPORT_PATH}/${encodeURIComponent(sessionId)}`;

export const CASE_MAKER_PATH = "/dashboard/admin/morning-report-cases";

export const caseMakerEditorPath = (caseId) =>
  `${CASE_MAKER_PATH}/${encodeURIComponent(caseId)}`;
